export const BOOKS_URL = EnvSettings.EBOOKS_URL;
export const ASSETS_URL = 'https://aqua-extended.s3.amazonaws.com/ereader_assets';
export const ACTIVITIES_DATA_PATH = 'activity_data';
export const SETTINGS_PATH = 'ereader.settings';

export const API_KC_URL = `${EnvSettings.API_URL}/games/v${EnvSettings.API_VERSION_KEYCLOAK}`;
export const GAME_STATE_URL = `${API_KC_URL}/gameState`;
